"use client";

import { NonceContext } from "@/shared/lib/security/nonce-context.js";
import type { WithChildren } from "@/shared/lib/types/with-children.js";

type NonceProviderProps = {
  readonly nonce: string;
} & WithChildren;

export const NonceProvider = ({ nonce, children }: NonceProviderProps) => (
  <NonceContext value={nonce}>{children}</NonceContext>
);
